module.exports = __webpack_public_path__ + "static/media/cancel11.9fb6b3bd.png";